// extracted by mini-css-extract-plugin
module.exports = {"grid":"products_grid__2cp1q","bg":"products_bg__tPgIF"};